import { Box } from "@mui/material";
import InsuranceReport from "../Insurance Report/Report";
import PageHeader from "../../ui/PageHeader";

function Report() {
  return (
    <Box>
      <PageHeader
        title="Insurance report"
        subtitle="Premium charged, uncharged and cumulative for approved policies. Pick a period and generate."
      />
      <InsuranceReport />
    </Box>
  );
}

export default Report;
